var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.875098,
    y: 1.20371,
    width: 65.45,
    height: 65.45,
    rx: 32.725,
    fill: "#1DA1F2",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.875098,
    y: 1.20371,
    width: 65.45,
    height: 65.45,
    rx: 32.725,
    stroke: "#E6E6E6",
    strokeWidth: 0.55
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6316_2951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.1997 18.5283H18.1997V50.5283H50.1997V18.5283Z",
    fill: "#1DA1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8665 27.8613C44.0665 28.2613 43.2665 28.3947 42.3332 28.528C43.2665 27.9947 43.9332 27.1947 44.1999 26.128C43.3999 26.6613 42.4665 26.928 41.3999 27.1947C40.5999 26.3947 39.3999 25.8613 38.1999 25.8613C35.3999 25.8613 33.2665 28.528 33.9332 31.1947C30.3332 31.0613 27.1332 29.328 24.8665 26.6613C23.6665 28.6613 24.3332 31.1947 26.1999 32.528C25.5332 32.528 24.8665 32.2613 24.1999 31.9947C24.1999 33.9947 25.6665 35.8613 27.6665 36.3947C26.9999 36.528 26.3332 36.6613 25.6665 36.528C26.1999 38.2613 27.7999 39.5947 29.7999 39.5947C28.1999 40.7947 25.7999 41.4613 23.5332 41.1947C25.5332 42.3947 27.7999 43.1947 30.1999 43.1947C38.3332 43.1947 42.8665 36.3947 42.5999 30.128C43.5332 29.5947 44.3332 28.7947 44.8665 27.8613Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6316_2951"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.1997,
    y: 18.5283,
    width: 32,
    height: 32,
    rx: 8.8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterShare);
export default __webpack_public_path__ + "static/media/twitter_share.5141f43adeb56dacda508ef4443b6fae.svg";
export { ForwardRef as ReactComponent };